
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The secret for signing webhooks.`}</p>
    <p>{`This must be specified if `}<inlineCode parentName="p">{`signingAlgorithmCode`}</inlineCode>{` is not `}<inlineCode parentName="p">{`None`}</inlineCode>{`.
It is used as the key to generate a message authentication code for each request.`}</p>
    <p>{`The secret should be a random string with high entropy that is not reused for any other purpose.`}</p>
    <p>{`This field has a maximum length of 255 bytes in UTF-8 encoding.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;